// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ta-2";
export var container = "_ta-4";
export var dismissButton = "_ta-3";
export var hasPaddingBottom = "_ta-6";
export var last = "_ta-e";
export var scrollbarThumb = "_ta-c";
export var scrollbarTrack = "_ta-b";
export var selected = "_ta-9";
export var spin = "_ta-1";
export var spinning = "_ta-0";
export var suggestionItem = "_ta-d";
export var suggestionsPanel = "_ta-5";
export var tonePill = "_ta-8";
export var tonesContainer = "_ta-7";
export var unselected = "_ta-a";